<template>
  <div @click="startTimer" @keyup="startTimer" @mouseup="startTimer" @mousemove="startTimer" @mousedown="startTimer">
    <el-card :style="cardHeight">
      <div class="tab-header" style="padding-bottom: 40px; border-bottom: 1px solid #EBEEF5;">
        <span style="float: left;color:#5ddddc;margin-right: 5px">|</span>
        <span style="font-weight: bolder;float: left;font-size: 15px">医教类项目信息</span>
        <el-button type="primary" size="small" style=" float: right; margin-bottom: 10px" @click="handleAddClick"
                   v-if= "this.$route.query.flag == 'add' || this.$route.query.flag == 'update' ">
          新增医教类项目信息
        </el-button>
      </div>

      <div class="tab-body" :style="tabHeight" style="margin-top: 20px; padding-bottom: 20px">
        <el-scrollbar style="height: 100%;" ref="scrollbar">
          <el-table v-loading="data.isLoading" :data="data.list" border size="small">
            <el-table-column align="center" prop="name" label="名称" fixed :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="taskSource" label="任务来源" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="lv" label="级别" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="funding" label="经费" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="year" label="年度" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="操作" align="center" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button style="border:0px !important;" type="text" size="small" @click="handleViewClick(scope.row)">查 看
                </el-button>
                <el-button v-if="$route.query.flag == 'add' || $route.query.flag == 'update'" style="border:0px !important;" type="text" size="small"
                           @click="handleUpdateClick(scope.row,scope.$index)">修 改
                </el-button>
                <el-button v-if="$route.query.flag == 'add' || $route.query.flag == 'update'" style="border:0px !important;" type="text" size="small"
                           @click="handleDeleteClick(scope.row)">删 除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="float: right"
            background
            layout="prev, pager, next"
            :total="pagination.pageCount"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            @current-change="clickChangePage">
          </el-pagination>
        </el-scrollbar>
      </div>

      <el-dialog :closeOnClickModal="false" :visible.sync="dialog.isShow" class="spec-dialog" @close="handleCloseDialog">
        <div class="dialog-title" slot="title">
          <template v-if="Object.is(dialog.dialogType,dialogType.add)">新增医教类项目信息</template>
          <template v-if="Object.is(dialog.dialogType,dialogType.view)">查看医教类项目信息</template>
          <template v-if="Object.is(dialog.dialogType,dialogType.update)">编辑医教类项目信息</template>
      </div>
        <el-form label-width="100px" v-loading="dialog.isLoading" :rules="rules" ref="ruleForm" :model="dialog.form">
          <el-form-item label="名称" prop="name">
            <el-input v-model="dialog.form.name" type="text" placeholder="请输入名称" clearable
                      :disabled="Object.is(dialogType.view, dialog.dialogType)" >
            </el-input>
          </el-form-item>
          <el-form-item label="任务来源" prop="taskSource">
            <el-input v-model="dialog.form.taskSource" type="text" placeholder="请输入任务来源" clearable
                      :disabled="Object.is(dialogType.view, dialog.dialogType)" >
            </el-input>
          </el-form-item>

          <el-form-item label="级别" prop="lv">
            <el-input v-model="dialog.form.lv" type="text" placeholder="请输入级别" clearable
                      :disabled="Object.is(dialogType.view, dialog.dialogType)" >
            </el-input>
          </el-form-item>
          <el-form-item label="经费" prop="funding">
            <el-input-number :precision="2" v-model="dialog.form.funding" style="width: 100%" :controls="false" type="text" placeholder="请输入经费" clearable
                      :disabled="Object.is(dialogType.view, dialog.dialogType)" >
            </el-input-number>
          </el-form-item>
          <el-form-item label="年度" prop="year">
            <el-input v-model="dialog.form.year" type="text" placeholder="请输入年度" clearable
                      :disabled="Object.is(dialogType.view, dialog.dialogType)" >
            </el-input>
          </el-form-item>
        </el-form>
        <template slot="footer" >
          <el-button @click="handleCommitDialog" size="small" type="primary" v-show="this.$route.query.flag != 'view' && dialog.editedFlag">提交</el-button>
          <el-button @click="handleCloseDialog" size="small" type="info">取消</el-button>
        </template>
      </el-dialog>
    </el-card>

<!--    <el-card style="margin-top: 10px;padding-bottom: 20px;text-align: center">-->
<!--      <el-button type="info" size="small" @click="handleCancelClick">取消</el-button>-->
<!--      <el-button type="primary" size="small" v-show="this.$route.query.flag != 'view'" @click="handleCommitClick">提交</el-button>-->
<!--      <el-button type="primary" size="small" style="float: left" icon="el-icon-arrow-left" @click="goPrePageClick">上一页</el-button>-->
<!--      <el-button type="primary" size="small" style="float: right" @click="goNextPageClick">下一页<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i></el-button>-->
<!--    </el-card>-->
  </div>
</template>

<script>
import * as constantsRules from '@/constants/constantRules'
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {mapState} from "vuex";
import {Message} from "element-ui";
import {DIALOG_TYPE_ADD,DIALOG_TYPE_VIEW,DIALOG_TYPE_UPDATE,ATTA_FILE_SUF_LIST,ATTA_FILE_SHOW_TYPE,
        CARD_HEIGHT_TYPE,TAB_HEIGHT_TYPE,PAGE_SIZE_TYPE} from '@/constants/constants'

export default {
  name: "TeachingInfo",
  data() {
    return {
      pagination: {
        //数据页总数
        pageCount: 1,
        //当前页
        currentPage: 1,
        //页数据大小
        pageSize: PAGE_SIZE_TYPE,
      },
      data: {
        isLoading: false,
        list:[],
        allData:[],
      },
      dialogType: {
        add: DIALOG_TYPE_ADD,
        view: DIALOG_TYPE_VIEW,
        update: DIALOG_TYPE_UPDATE
      },
      fileDialog:{
        attachmentName:'',
        cd:'001-002',
        showFileList: [],
        fileList: [],
        tableDataList:[],
        attaFileSuf:ATTA_FILE_SUF_LIST,
        attaFileType:ATTA_FILE_SHOW_TYPE,
        drawerVisible: false,
        fileSaveBtnLoading: false,
        updateFlag:false,
        uploadLoading:false,
      },
      dialog: {
        dialogType: null,
        editedFlag: false,
        isShow: false,
        isLoading: false,
        form:
          {
            id:'',
            name: '',
            taskSource: '',
            lv: '',
            funding:'',
            year: '',
            userId:'',
          }
      },
      cardHeight: {
        height: ''
      },
      tabHeight: {
        height: ''
      },
      timeOut: '',   //定时器
      updateIndex: '',     //修改的索引
      updateCurrIndex: '',  //修改的当前索引
      rules: constantsRules.TeachingInfoRules,
      editSelf:'0'
    }
  },

  watch: {
    "data.allData.length": {
      handler(newVal, oldVal) {
        this.pagination.pageCount = this.data.allData.length
        //新增
        if (newVal > oldVal) {
          if (oldVal !== 0) {
            this.clickChangePage((Math.ceil(this.data.allData.length / this.pagination.pageSize)))
          }
          //删除
        } else if (newVal < oldVal) {
          this.clickChangePage((this.pagination.currentPage === 1 || this.data.list.length !== 0) ? this.pagination.currentPage : this.pagination.currentPage - 1)
        }
      },
      deep:true
    },

  },

  mounted() {
    //进入页面显示数据到表单中
    // this.data.list = this.eimsUserInfTeachings;
    //所有数据,非仅当前页面的数据
    this.data.allData = this.eimsUserInfTeachings;
    this.pagination.pageCount = this.eimsUserInfTeachings.length
    this.changeShowData()

    //若是新增或者修改页面，就启用定时器
    if (this.$route.query.flag == "add" || this.$route.query.flag == 'update'){
      this.startTimer();
    }
  },

  //清除定时器
  beforeDestroy() {
    let that = this;
    that.$once('hook:beforeDestroy',() =>{
      clearInterval(that.timeOut)
    })
  },

  methods: {
    //设置自适应高度
    getHeight() {
      this.cardHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE ) + 'px';
      this.tabHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE - TAB_HEIGHT_TYPE ) + 'px';
    },

    //页面单击修改页面的时候触发修改页码
    clickChangePage(page) {
      this.pagination.currentPage = page
      this.changeShowData()
    },

    //修改页面显示的数据
    changeShowData() {
      this.data.list = []
      let start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      let end = this.pagination.currentPage * this.pagination.pageSize > this.data.allData.length ? this.data.allData.length : this.pagination.currentPage * this.pagination.pageSize
      for (let i = start; i < end; i++) {
        this.data.list.push(this.data.allData[i])
      }
    },

    //页面5分钟无操作时自动调用接口
    startTimer() {
      let that = this;
      clearInterval(that.timeOut);
      that.timeOut = setInterval(()=>{
        that.handleCommitClick("auto");
      },5*60*1000)
    },

    //点击添加出现弹窗
    handleAddClick() {
      this.dialog.isShow = true;
      // this.dialog.form = {}
      this.dialog.dialogType = DIALOG_TYPE_ADD;
      this.dialog.editedFlag = true;
      this.dialog.form.attachIds = [];
    },


    //点击查看表单信息
    handleViewClick(row) {
      let that = this;
      that.dialog.isShow = true;
      that.dialog.dialogType = DIALOG_TYPE_VIEW;
      let list = that.eimsUserInfTeachings;
      list.forEach((arr) => {
        if (list.indexOf(arr) == list.indexOf(row)){
          that.dialog.form = JSON.parse(JSON.stringify(arr));
        }
      })
    },

    //点击修改表单信息
    handleUpdateClick(row,idx) {
      this.dialog.editedFlag = true;
      let that = this;
      that.dialog.isShow = true;
      that.dialog.dialogType = DIALOG_TYPE_UPDATE;
      let list = that.eimsUserInfTeachings;
      list.forEach((arr) => {
        if (list.indexOf(arr) == list.indexOf(row)) {
          let arr1 = JSON.parse(JSON.stringify(arr));
          that.dialog.form = arr1;
          that.updateIndex = list.indexOf(row);
        }
      })
      that.updateCurrIndex = idx;
    },

    //点击删除表单信息
    handleDeleteClick(row) {
      let that = this;
      that.$confirm('确定将' + row.name + '删除？',{
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>{
        this.deleteTeachingById(row)
      }).catch(()=>{})
    },


    deleteTeachingById(row){
      let obj={
        token:cookie.getCookie("token"),
        data:{
          id:row.id,
          userId:row.userId,
        }
      }
      //移除成功和失败不需要提示
      http.post(window.config.api.baseUrl + '/eims-api/teaching/delete', obj).then(response => {
        if(response.data.code === '00000'){
          Message.success("医教类项目信息删除成功")
          this.updateDataCache(row)
        }
      }).finally(() => {

      })
    },

    updateDataCache(row){
      let that = this;
      let list = that.data.list;
      list.forEach((arr) => {
        if (list.indexOf(arr) == list.indexOf(row)) {
          that.data.list.splice(list.indexOf(arr),1)
          //删除总数据中的某一项
          that.$store.state.teachingInfoModule.eimsUserInfTeachings.splice(that.data.allData.indexOf(row),1)
        }
      })
    },

    //提交弹窗信息
    handleCommitDialog(row){
      if(!this.validateDialogForm()){
        return false
      }
      this.saveTeachingInfo();
      //if (this.dialogType.add == this.dialog.dialogType){
      //  this.dialog.form.userId = this.userId;
      //  this.data.list.push(this.dialog.form);
      //  this.data.allData.push(this.dialog.form);
      //}else if(this.dialogType.update == this.dialog.dialogType){
      //  this.data.allData.splice(this.updateIndex,1,this.dialog.form)
      //  this.data.list.splice(this.updateCurrIndex,1,this.dialog.form);
      //}
    },

    //最后保存医教类项目的信息
    saveTeachingInfo(){
      this.dialog.form.userId=this.userId
      let obj={
        token:cookie.getCookie("token"),
        data:{
          "eimsUserInfTeachings":this.dialog.form,
          "userId": this.userUserId
        }
      }
      http.post(window.config.api.baseUrl + '/eims-api/teaching/update', obj).then(response => {
        if (response.data.code === '00000'){
          if(Object.is(this.dialogType.update, this.dialog.dialogType)){
            Message.success("医教类项目修改成功")
          }else if(Object.is(this.dialogType.add, this.dialog.dialogType)){
            Message.success("医教类项目新增成功")
          }
          //将数据添加到缓存中
          this.pushDataToCache(response.data.data.userInfTeaching)
        }
      }).finally(() => {
        this.dialog.isShow = false;
      })
    },


    //相关操作
    pushDataToCache(form){
      if (this.dialogType.add == this.dialog.dialogType){
        this.data.list.push(form);
        this.data.allData.push(form);
      }else if(this.dialogType.update == this.dialog.dialogType){
        //设置附件的列表数据
        this.data.allData.splice(this.updateIndex,1,form)
        this.data.list.splice(this.updateCurrIndex,1,form);
      }
    },

    //提交操作的数据
    handleCommitClick(param){
      let that = this;
      //将页面信息存到modules中
      that.$store.dispatch("getTeachingInfo", {"eimsUserInfTeachings": that.data.allData,"userId": that.userId});
      //提交数据
      let flag = 'UPDATE';
      let editSelf = this.editSelf;
      //如果userModule中的userId有值，则创建用户变成修改用户
      // if(that.userUserId){
      //   flag = "UPDATE"
      // }
      //userModule中的userId没有值或者userModule中userId值等于输入框中的userId值，方可调用接口
      if (!that.userUserId || that.userUserId == that.userId){
        that.$store.dispatch("updateOrInsertMemberInfo",{flag,editSelf}).then(value => {
          if(value.data.code == '00000'){
            if (this.$route.query.flag == "add"){
              Message.success({message:"创建用户成功", showClose: true});
            }else if(this.$route.query.flag == "update"){
              Message.success({message:"修改用户成功", showClose: true});
            }
            if (param != "auto"){
              this.$router.push({path:'/user/list'});
            }
            this.$store.dispatch("getEimsUser",{"userId": this.userId})
          }
        })
      }
    },

    handleCloseDialog(){
      // this.dialog.form = {};
      // this.$refs['ruleForm'].resetFields();
      this.dialog.isShow = false;
      this.$refs['ruleForm'].resetFields();
      Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
      // this.fileDialog.fileList = [];
      // this.fileDialog.showFileList = [];
      this.dialog.editedFlag = false

    },
    handleCancelClick(){
      if (this.$route.query.path == '/user/approve') {
        this.$router.push({path:'/user/approve'});
      }else {
        this.$router.push({path:'/user/list'});
      }
    },
    //跳转到上一个页面
    goPrePageClick(){
      let data='/user/info/subject';   //要传的值
      //子路由通过$emit触发父级路由中的方法
      this.$emit('childClick',data);
    },
    //跳转到下一个页面
    goNextPageClick(){
      let data = '/user/info/gcp';
      this.$emit('childClick', data);
    },
    validateFileForm() {
      return true;
    },
    validateDialogForm() {
      let result = false;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },

    //外层提交，基本信息页需要先保存，所以需要通信，但本质子路由页面都需要此方法
    commitEimsUserBasic(){

    }
  },

  created() {
    window.addEventListener('resize', this.getHeight);
    this.getHeight();
    this.editSelf = this.$route.query.isSelf;

  },

  destroyed() {
    this.$store.dispatch("getTeachingInfo", {"eimsUserInfTeachings": this.data.allData,"userId": this.userId});
    window.removeEventListener('resize', this.getHeight);
  },

  computed: {
    fileData:function () {
      let list = [];
      for (let i in this.fileDialog.showFileList) {
        let temp = {};
        temp.fileName = this.fileDialog.showFileList[i];
        temp.attachmentName = '';
        temp.file = this.fileDialog.fileList[i].file;
        list.push(temp);
      }
      return list;
    },
    ...mapState({
      //仅需要当前页面需要的数据,无需设置其他的页面的module数据
      eimsUserInfTeachings: state => state.teachingInfoModule.eimsUserInfTeachings || [],
      userId: state => state.basicInfoModule.userId,
      userUserId: state => state.userModule.userId,
      majorDepartId: state => state.basicInfoModule.majorDepartId,
      name: state => state.basicInfoModule.name,
    })
  }

}
</script>

<style scoped>
/deep/ .spec-dialog .el-dialog__body {
  /*padding: 3px 30px;*/
  overflow-y: auto;
  height: calc(100vh - 200px);

}
.dialog-title{
  font-size: 17px;
  text-align: center;
}

.el-dialog__wrapper.spec-dialog{
  overflow: hidden !important;
  top: auto !important;
}

.card {
  overflow-y: auto /* 开启滚动显示溢出内容 */
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

/*关闭横向滚动条*/
/deep/ .el-scrollbar__bar.is-horizontal{
  height: 0px;
}

</style>



// WEBPACK FOOTER //
// src/pages/member/memberInfo/TeachingInfo.vue